import { NavLink } from "react-router-dom";

import { colors } from "./navbar";

export type SubMenu = {
  slug: string;
  title?: string;
};

export type SubMenuSeparator = {
  separator: true;
};

export type SubMenuItem = SubMenu | SubMenuSeparator;

export function SubMenu({
  menu,
  color,
}: {
  menu: SubMenuItem[];
  color: keyof typeof colors;
}) {
  return (
    <ul
      className={`w-full rounded-xs py-2 flex flex-col ${colors[color].background}`}
    >
      {menu.map((page, index) => (
        <li key={`sub-menu-${index}`}>
          {"separator" in page ? (
            <div className="h-[1px] w-full bg-gray-200" />
          ) : (
            <NavLink
              className={`px-3 py-2 block ${colors[color].text} ${colors[color].hover} ${isActive(page.slug, location.pathname) ? colors[color].active : ""}`}
              to={page.slug}
            >
              {page.title || page.slug}
            </NavLink>
          )}
        </li>
      ))}
    </ul>
  );
}

function isActive(slug: string, pathname: string): boolean {
  return pathname.startsWith(slug);
  const slugParts = slug.split("/");
  const pathnameParts = pathname.split("/");

  if (slugParts.length !== pathnameParts.length) return false;

  return slugParts.every((part, index) => part === pathnameParts[index]);
}
